// import React, { useState } from "react";
// import TownPlanningSidebar from "../components/TownPlanningSidebar";
// import styles from "../styles/TownPlanningDashboard.module.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faBars } from "@fortawesome/free-solid-svg-icons";
// import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
// import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
// import { FaArrowLeft, FaSearch, FaDownload, FaFilter, FaCalculator, FaFilePdf } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";

// export default function Feedback() {
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
// const navigate = useNavigate();
//   const handleBack = () => {
//     navigate("/")
//   };
//   return (
//     <div
//       className={styles.homeScreenContainer}
//       style={{
//         height: "100vh",
//         overflow: "hidden",
//         display: "flex",
//         flexDirection: "column",
//       }}
//     >
//       {/* Header */}
//       <div className={styles.homeScreenHeader}>
//         {/* <button
//           onClick={() => setIsSidebarOpen(true)}
//           className={styles.homeScreenMenuBtn}
//         >
//           <FontAwesomeIcon icon={faBars} />
//         </button> */}

        
//         <button className={styles.homeScreenMenuBtn} onClick={handleBack}>
//           <FaArrowLeft />
//         </button>

//         <TownPlanningSidebar
//           isOpen={isSidebarOpen}
//           onClose={() => setIsSidebarOpen(false)}
//         />

//         <h2 style={{ color: "white" }}>Feedback</h2>
//       </div>

//       {/* Scrollable Content Area */}
//       <div
//         style={{
//           flex: 1,
//           overflowY: "auto",
//           padding: "20px",
//           color: "white",
//         }}
//       ><div
//   style={{
//     display: "flex",
//     flexDirection: "column",
//     gap: "20px",
//     fontSize: "18px",
//   }}
// >
//   {/* WhatsApp Row */}
//   <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
//     <FontAwesomeIcon icon={faWhatsapp} size="2x" />
//     <span>+91 9922979783</span>
//   </div>

//   {/* Email Row */}
//   <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
//     <FontAwesomeIcon icon={faEnvelope} size="2x" />
//     <span>sbn.parola@gmail.com</span>
//   </div>
// </div>

//       </div>
//     </div>
//   );
// }







import React from "react";
import { useNavigate } from "react-router-dom";
import { 
  ArrowLeft, 
  MessageSquare, 
  Mail, 
  Phone, 
  ExternalLink,
  MessageCircle
} from "lucide-react";

export default function Feedback() {
  const navigate = useNavigate();
  
  const handleBack = () => {
    navigate("/");
  };

  return (
    <div className="min-h-screen bg-slate-100 flex flex-col">
      {/* --- HEADER --- */}
      <div className="bg-white border-b border-slate-200 sticky top-0 z-30">
        <div className="max-w-3xl mx-auto px-4 h-16 flex items-center gap-4">
          <button 
            onClick={handleBack} 
            className="p-2.5 hover:bg-slate-100 rounded-xl transition-all text-slate-600"
          >
            <ArrowLeft size={22} />
          </button>
          <h2 className="text-lg font-black text-slate-900 uppercase tracking-tight">Support</h2>
        </div>
      </div>

      {/* --- CONTENT AREA --- */}
      <main className="flex-1 max-w-2xl mx-auto px-4 py-12 w-full">
        <div className="bg-white rounded-[2.5rem] shadow-2xl shadow-slate-400/30 ring-1 ring-slate-200 overflow-hidden">
          
          {/* Top Decorative Banner */}
          <div className="p-10 bg-[#111827] text-white">
            <div className="w-16 h-16 bg-orange-600 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg shadow-orange-900/40">
              <MessageSquare size={32} />
            </div>
            <h3 className="text-2xl font-black tracking-tight uppercase text-center">Get in Touch</h3>
            <p className="text-xs text-slate-400 font-bold tracking-[0.2em] mt-2 uppercase text-center">Feedback & Queries</p>
          </div>

          <div className="p-8 space-y-6">
            
            {/* WhatsApp Card */}
            <a 
              href="https://wa.me/919922979783" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center justify-between p-6 bg-emerald-50 border border-emerald-100 rounded-3xl hover:shadow-lg transition-all group"
            >
              <div className="flex items-center gap-5">
                <div className="w-14 h-14 bg-emerald-500 rounded-2xl flex items-center justify-center text-white shadow-lg shadow-emerald-200">
                  <MessageCircle size={28} />
                </div>
                <div>
                  <p className="text-[10px] font-black text-emerald-700 uppercase tracking-widest mb-1">WhatsApp Support</p>
                  <p className="text-lg font-black text-slate-900">+91 99229 79783</p>
                </div>
              </div>
              <ExternalLink className="text-emerald-300 group-hover:text-emerald-500 transition-colors" size={20} />
            </a>

            {/* Email Card */}
            <a 
              href="mailto:sbn.parola@gmail.com"
              className="flex items-center justify-between p-6 bg-blue-50 border border-blue-100 rounded-3xl hover:shadow-lg transition-all group"
            >
              <div className="flex items-center gap-5">
                <div className="w-14 h-14 bg-blue-500 rounded-2xl flex items-center justify-center text-white shadow-lg shadow-blue-200">
                  <Mail size={28} />
                </div>
                <div>
                  <p className="text-[10px] font-black text-blue-700 uppercase tracking-widest mb-1">Email Enquiries</p>
                  <p className="text-lg font-black text-slate-900">sbn.parola@gmail.com</p>
                </div>
              </div>
              <ExternalLink className="text-blue-300 group-hover:text-blue-500 transition-colors" size={20} />
            </a>

            {/* Help Text */}
            <div className="pt-8 text-center">
              <p className="text-xs text-slate-400 font-bold uppercase tracking-wider leading-relaxed max-w-[280px] mx-auto">
                Our team usually responds within 24-48 business hours.
              </p>
            </div>

          </div>
        </div>

        <p className="text-center mt-10 text-slate-400 text-[10px] font-bold uppercase tracking-widest">
          PropIntel • Customer Experience Team
        </p>
      </main>
    </div>
  );
}